import { FC, useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import styles from './PunchupDetailText.module.css';

const CHEVRON_SIZE = 12;

export interface PunchupDetailTextProps {
	/** Primary body text — black, sm font. Always visible. */
	main: string;
	/** Optional supplementary explanation — muted, xs font. */
	secondary?: string;
	/**
	 * When true the secondary text is hidden behind a "More info" toggle.
	 * When false (default) the secondary text is shown directly below the main text.
	 * Ignored when secondary is absent.
	 */
	collapsible?: boolean;
}

export const PunchupDetailText: FC<PunchupDetailTextProps> = ({ main, secondary, collapsible = false }) => {
	const [expanded, setExpanded] = useState(false);

	const showSecondaryInline = !!secondary && !collapsible;
	const showToggle = !!secondary && collapsible;

	return (
		<div className={styles.root}>
			<p className={styles.main}>{main}</p>
			{showSecondaryInline && <p className={styles.secondary}>{secondary}</p>}
			{showToggle && (
				<>
					<button
						type="button"
						className={styles.expandBtn}
						onClick={() => setExpanded((v) => !v)}
						aria-expanded={expanded}
					>
						{expanded ? (
							<>
								Less <ChevronUp size={CHEVRON_SIZE} />
							</>
						) : (
							<>
								More info <ChevronDown size={CHEVRON_SIZE} />
							</>
						)}
					</button>
					<div className={[styles.secondaryWrapper, expanded ? styles.isOpen : ''].filter(Boolean).join(' ')}>
						<div className={styles.secondaryInner}>
							<p className={styles.secondary}>{secondary}</p>
						</div>
					</div>
				</>
			)}
		</div>
	);
};
